import React from "react";
import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";
import { mediaQueries } from "../../../../../../theme";
import { ManualUnitValues } from "../../../../../../types/ManualUnitValues";
import { Flex } from "../../../../../Flex";
import { Span } from "../../../../../Span";

interface Props {
  units: ManualUnitValues[];
}

const Table = styled.table<LayoutProps>`
  ${layout}
  text-align: left;
  display: table;

  ${mediaQueries.mediumDevice} {
    display: none;
  }
`;

const TableCell = styled.td<SpaceProps>`
  ${space}
  border-top: 1px solid;
  border-color: ${({ theme }) => theme.colors.neutrals.ln30};
`;

const LabelWrapper = styled(Span)`
  color: ${({ theme }) => theme.colors.neutrals.mn80};
  min-width: 0;
  flex-basis: 0;
`;

const ValueWrapper = styled(Span)`
  min-width: 0;
  flex-basis: 0;
  text-transform: capitalize;
`;

export const ReviewFormMobileMeteredUnits: React.FC<Props> = ({ units }) => {
  return (
    <Table>
      <thead></thead>
      <tbody>
        {units.map((unit, index) => {
          return (
            <tr
              data-testid={`mobile-metered-unit-row-${index + 1}`}
              key={index}
            >
              <TableCell pt={2} pb={3}>
                <Flex flexDirection="row" mb={2}>
                  <LabelWrapper lineHeight={2} flexGrow={0.5}>
                    Unit/Lot Number
                  </LabelWrapper>
                  <ValueWrapper
                    data-testid={`unit-${index + 1}-number`}
                    lineHeight={2}
                    flexGrow={0.5}
                  >
                    {unit.unitNumber}
                  </ValueWrapper>
                </Flex>
                <Flex flexDirection="row" mb={2}>
                  <LabelWrapper lineHeight={2} flexGrow={0.5}>
                    Supply Type
                  </LabelWrapper>
                  <ValueWrapper
                    data-testid={`unit-${index + 1}-type`}
                    lineHeight={2}
                    flexGrow={0.5}
                  >
                    {unit.type}
                  </ValueWrapper>
                </Flex>
                <Flex flexDirection="row" mb={2}>
                  <LabelWrapper lineHeight={2} flexGrow={0.5}>
                    Phase
                  </LabelWrapper>
                  <ValueWrapper
                    data-testid={`unit-${index + 1}-phase`}
                    lineHeight={2}
                    flexGrow={0.5}
                  >
                    {unit.phase}
                  </ValueWrapper>
                </Flex>
                <Flex flexDirection="row" mb={2}>
                  <LabelWrapper lineHeight={2} flexGrow={0.5}>
                    Fuse (Amp)
                  </LabelWrapper>
                  <ValueWrapper
                    data-testid={`unit-${index + 1}-fuse`}
                    lineHeight={2}
                    flexGrow={0.5}
                  >
                    {unit.fuseAmp}
                  </ValueWrapper>
                </Flex>
                <Flex flexDirection="row" mb={2}>
                  <LabelWrapper lineHeight={2} flexGrow={0.5}>
                    Supply
                  </LabelWrapper>
                  <ValueWrapper
                    data-testid={`unit-${index + 1}-supply`}
                    lineHeight={2}
                    flexGrow={0.5}
                  >
                    {unit.supply}
                  </ValueWrapper>
                </Flex>
              </TableCell>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
